import React, { Component, Fragment } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import propTypes from 'prop-types';

import { IconButton } from 'ui/Components';
import { tooltip } from 'ui/Icons';

/**
 * render a tooltip with popover content
 */
export default class HelpIcon extends Component {
  static propTypes = {
    id: propTypes.string.isRequired,
    message: propTypes.oneOfType([propTypes.func, propTypes.string]).isRequired,
    popoverClassName: propTypes.string,
    title: propTypes.string
  };

  static defaultProps = {
    popoverClassName: '',
    title: ''
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.toggle = this.toggle.bind(this);
  }

  /**
   * toggle this.state.isOpen
   */
  toggle() {
    this.setState(ps => ({ isOpen: !ps.isOpen }));
  }

  render() {
    const { id, message: Message, popoverClassName, title } = this.props;
    const { isOpen } = this.state;

    const messageTestId = `${id}-help-message`;
    const body =
      typeof Message === 'string' ? (
        <div data-test-id={messageTestId} dangerouslySetInnerHTML={{ __html: Message }} />
      ) : (
        <Message data-test-id={messageTestId} />
      );

    return (
      <Fragment>
        <IconButton
          className="d-inline-block ml-2"
          alt="help text"
          icon={tooltip}
          id={id}
          noMargin
          rem={1.5}
          onClick={this.toggle}
        />
        <Popover
          className={popoverClassName}
          placement="top"
          isOpen={isOpen}
          target={id}
          toggle={this.toggle}
        >
          {title && <PopoverHeader>{title}</PopoverHeader>}
          <PopoverBody>{body}</PopoverBody>
        </Popover>
      </Fragment>
    );
  }
}
